import { render, staticRenderFns } from "./ShippingEligibilityInfo.vue?vue&type=template&id=522f9d83&scoped=true&"
import script from "./ShippingEligibilityInfo.vue?vue&type=script&lang=js&"
export * from "./ShippingEligibilityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShippingEligibilityInfo.vue?vue&type=style&index=0&id=522f9d83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f9d83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522f9d83')) {
      api.createRecord('522f9d83', component.options)
    } else {
      api.reload('522f9d83', component.options)
    }
    module.hot.accept("./ShippingEligibilityInfo.vue?vue&type=template&id=522f9d83&scoped=true&", function () {
      api.rerender('522f9d83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/CustomerRequest/CustomerRequestComponents/ShippingEligibilityInfo.vue"
export default component.exports